import React, { useEffect, useState } from "react";

const DashboardBloackB = ({ assetNatureData, assetSegmentData }) => {
  const [selected, setSelected] = useState("Nature of trade");
  const [biggestNum, setBiggestNum] = useState();
  const [biggestSegmentNum, setBiggestSegmentNum] = useState();
  const [smallestNum, setSmallestNum] = useState();
  const [smallestSegmentNum, setSmallestSegmentNum] = useState();
  const [natureWidths, setNatureWidths] = useState();
  const [natureWidthSmall, setNatureWidthSmall] = useState();
  const [segWidths, setSegWidths] = useState();
  const [segWidthSmall, setSegWidthSmall] = useState();
  const configData = [
    {
      label: "Speculative",
      data: assetNatureData?.speculative ? assetNatureData?.speculative : 0,
      backgroundColor: "#70C579",
    },
    {
      label: "Positional",
      data: assetNatureData?.positional ? assetNatureData?.positional : 0,
      backgroundColor: "#ED6E25",
    },
    {
      label: "Long Term",
      data: assetNatureData?.long_term ? assetNatureData?.long_term : 0,
      backgroundColor: "#1578B9",
    },
  ];

  const configSegmentData = [
    {
      label: "EQ",
      data:
        assetSegmentData && assetSegmentData["EQ"] ? assetSegmentData["EQ"] : 0,
      backgroundColor: "#70C579",
    },
    {
      label: "F&O",
      data:
        assetSegmentData && assetSegmentData["F&O"]
          ? assetSegmentData["F&O"]
          : 0,
      backgroundColor: "#ED6E25",
    },
    {
      label: "CUR",
      data:
        assetSegmentData && assetSegmentData["CUR"]
          ? assetSegmentData["CUR"]
          : 0,
      backgroundColor: "#1578B9",
    },
    {
      label: "MCX",
      data:
        assetSegmentData && assetSegmentData["MCX"]
          ? assetSegmentData["MCX"]
          : 0,
      backgroundColor: "#CE5D9C",
    },
    {
      label: "NCDEX",
      data:
        assetSegmentData && assetSegmentData["NCDEX"]
          ? assetSegmentData["NCDEX"]
          : 0,
      backgroundColor: "#5A4496",
    },
  ];

  useEffect(() => {
    const biggestVal =
      configData && configData?.slice().sort((a, b) => b.data - a.data);
    const biggestSegVal =
      configSegmentData &&
      configSegmentData?.slice().sort((a, b) => b.data - a.data);
    const smallestVal = configData?.slice().sort((a, b) => a.data - b.data);
    const smallestSegVal = configSegmentData
      ?.slice()
      .sort((a, b) => a.data - b.data);
    setBiggestNum(biggestVal[0].data && biggestVal[0]?.data);
    setBiggestSegmentNum(biggestSegVal[0].data && biggestSegVal[0]?.data);
    setSmallestNum(smallestVal[0].data && Math.abs(smallestVal[0]?.data));
    setSmallestSegmentNum(
      smallestSegVal[0]?.data && Math.abs(smallestSegVal[0]?.data),
    );
  }, [assetNatureData, assetSegmentData]);

  const overallWidth = biggestNum + smallestNum;
  const overallWidthSegment = biggestSegmentNum + smallestSegmentNum;
  const positiveWidth = ((biggestNum * 100) / overallWidth) * 2;
  const negativeWidth = ((smallestNum * 100) / overallWidth) * 2;

  const formatDataWIDTH = () => {
    if (biggestNum) {
      let assetArray = [];
      configData.forEach((item) => {
        let assetdata = Math.floor(((item.data * 100) / overallWidth) * 2);
        assetArray.push(String(Math.abs(assetdata)));
      });
    }
  };

  const formatData = () => {
    if (biggestNum) {
      let assetArray = [];
      configData.forEach((item) => {
        let assetdata = Math.floor(((item.data * 100) / overallWidth) * 2);
        assetArray.push(String(Math.abs(assetdata)));
      });
      setNatureWidths(assetArray);
    }
  };

  const formatSmallData = () => {
    if (smallestNum) {
      let assetArray = [];
      configData.forEach((item) => {
        let assetdata = Math.floor(((item.data * 100) / overallWidth) * 2);
        assetArray.push(Math.abs(String(assetdata)));
      });
      setNatureWidthSmall(assetArray);
    }
  };

  const formatSegData = () => {
    if (biggestSegmentNum) {
      let assetArray = [];
      configSegmentData.forEach((item) => {
        let assetdata = Math.floor(
          ((item.data * 100) / overallWidthSegment) * 2,
        );

        assetArray.push(Math.abs(String(assetdata)));
      });
      setSegWidths(assetArray);
    }
  };

  const formatSmallSegData = () => {
    if (smallestSegmentNum) {
      let assetArray = [];
      configSegmentData.forEach((item) => {
        let assetdata = Math.floor(
          ((item.data * 100) / overallWidthSegment) * 2,
        );
        assetArray.push(Math.abs(String(assetdata)));
      });

      setSegWidthSmall(assetArray);
    }
  };

  useEffect(() => {
    formatData();
    formatSmallData();
    formatSegData();
    formatSmallSegData();
    formatDataWIDTH();
  }, [biggestNum, smallestNum, biggestSegmentNum, biggestSegmentNum]);

  const segment = ["Nature of trade", "Segment"];

  let widths = String(79);

  return (
    <div className="flex h-full flex-col items-stretch justify-between text-sm font-bold text-neutral-800">
      <div className="flex justify-between">
        <h2 className="inline-block"> Asset Class </h2>
        <div>
          <select
            onChange={(e) => setSelected(e.target.value)}
            className="w-fit bg-white text-sm font-medium text-neutral-800 outline-none"
          >
            {segment.map((item, i) => (
              <option value={item} key={i}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-auto flex max-md:justify-between max-md:w-full items-center justify-evenly gap-2">
        <div>
          {selected === "Nature of trade"
            ? configData?.map((data, idx) => (
                <div
                  key={idx}
                  className="flex items-center justify-between gap-3 "
                >
                  <div className="- flex items-center gap-2 py-3">
                    <div
                      className="aspect-square w-[20px] rounded-full bg-red-400"
                      style={{ backgroundColor: data?.backgroundColor }}
                    />
                    <div className="font-normal uppercase text-neutral-500">
                      {data?.label}
                    </div>
                  </div>
                </div>
              ))
            : configSegmentData?.map((data, idx) => (
                <div
                  key={idx}
                  className="flex items-center justify-between gap-3 "
                >
                  <div className="flex items-center gap-2 py-3">
                    <div
                      className="aspect-square w-[20px] rounded-full bg-red-400"
                      style={{ backgroundColor: data?.backgroundColor }}
                    />
                    <div className="font-normal uppercase text-neutral-500">
                      {data?.label}
                    </div>
                  </div>
                </div>
              ))}
        </div>
        <div className=" flex w-[200px] ">
          <div className=" flex h-[210px] w-full ">
            <div className="  h-[210px] w-full border-r-[1px] border-gray-200">
              {natureWidthSmall !== undefined &&
              selected === "Nature of trade" ? (
                <>
                  {natureWidthSmall[0] && assetNatureData?.speculative < 0 ? (
                    <div
                      className={`ml-auto mt-[50px] h-[20px] bg-[#A82525]`}
                      style={{ width: `${natureWidthSmall[0]}px` }}
                    ></div>
                  ) : (
                    <div
                      className={` transparent mt-[50px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                  {natureWidthSmall[1] && assetNatureData?.positional < 0 ? (
                    <div
                      className={`ml-auto mt-[24px] h-[20px] bg-[#A82525]`}
                      style={{ width: `${natureWidthSmall[1]}px` }}
                    ></div>
                  ) : (
                    <div
                      className={` transparent mt-[24px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                  {natureWidthSmall[2] && assetNatureData?.long_term < 0 ? (
                    <div
                      className={`ml-auto mt-[24px] h-[20px] bg-[#A82525]`}
                      style={{ width: `${natureWidthSmall[2]}px` }}
                    ></div>
                  ) : (
                    <div
                      className={` transparent mt-[24px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                </>
              ) : null}{" "}
              {segWidthSmall && selected === "Segment" ? (
                <>
                  {segWidthSmall[0] && assetSegmentData["EQ"] < 0 ? (
                    <div
                      className={` ml-auto mt-[6px] h-[20px] bg-[#A82525] text-[#a8252500]`}
                      style={{ width: `${segWidthSmall[0]}px` }}
                    >
                      {segWidthSmall[0]}
                    </div>
                  ) : (
                    <div
                      className={` transparent mt-[6px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                  {segWidthSmall[1] && assetSegmentData["F&O"] < 0 ? (
                    <div
                      className={` h-[20px ml-auto mt-[25px] bg-[#A82525] text-[#a8252500]`}
                      style={{ width: `${segWidthSmall[1]}px` }}
                    >
                      {segWidthSmall[1]}
                    </div>
                  ) : (
                    <div
                      className={` transparent mt-[25px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}

                  {segWidthSmall[2] && assetSegmentData["CUR"] < 0 ? (
                    <div
                      className={` h-[20px ml-auto mt-[25px] bg-[#A82525] text-[#a8252500]`}
                      style={{ width: `${segWidthSmall[2]}px` }}
                    >
                      {segWidthSmall[2]}
                    </div>
                  ) : (
                    <div
                      className={` transparent mt-[25px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                  {segWidthSmall[3] && assetSegmentData["MCX"] < 0 ? (
                    <div
                      className={` h-[20px ml-auto mt-[25px] bg-[#A82525] text-[#a8252500]`}
                      style={{ width: `${segWidthSmall[3]}px` }}
                    >
                      {segWidthSmall[3]}
                    </div>
                  ) : (
                    <div
                      className={` transparent mt-[25px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                  {segWidthSmall[4] && assetSegmentData["NCDEX"] < 0 ? (
                    <div
                      className={` h-[20px ml-auto mt-[25px] bg-[#A82525] text-[#a8252500]`}
                      style={{ width: `${segWidthSmall[4]}px` }}
                    >
                      {segWidthSmall[4]}
                    </div>
                  ) : (
                    <div
                      className={` transparent mt-[25px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                </>
              ) : null}
            </div>

            <div className=" h-[210px] w-full border-l-[1px] border-gray-200">
              {natureWidths !== undefined && selected === "Nature of trade" ? (
                <>
                  {natureWidths !== undefined &&
                  natureWidths[0] &&
                  assetNatureData?.speculative > 0 ? (
                    <div
                      className={` mt-[50px] h-[20px]  bg-[#25A86A]`}
                      style={{ width: `${natureWidths[0]}px` }}
                    ></div>
                  ) : (
                    <div
                      className={` transparent mt-[50px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                  {natureWidths !== undefined &&
                  natureWidths[1] &&
                  assetNatureData?.positional > 0 ? (
                    <div
                      className={` mt-[24px] h-[20px] bg-[#25A86A]`}
                      style={{ width: `${natureWidths[1]}px` }}
                    ></div>
                  ) : (
                    <div
                      className={` transparent mt-[24px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                  {natureWidths !== undefined &&
                  natureWidths[2] &&
                  assetNatureData?.long_term > 0 ? (
                    <div
                      className={` mt-[24px] h-[20px] w-[${natureWidths[2]}px] bg-[#25A86A]`}
                      style={{ width: `${natureWidths[2]}px` }}
                    ></div>
                  ) : (
                    <div
                      className={` transparent mt-[24px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                </>
              ) : null}{" "}
              {segWidths && selected === "Segment" ? (
                <>
                  {segWidths[0] && assetSegmentData["EQ"] > 0 ? (
                    <div
                      className={` mt-[6px] h-[20px] bg-[#25A86A] text-[#a8252500]`}
                      style={{ width: `${String(segWidths[0])}px` }}
                    >
                      {segWidths[0]}
                    </div>
                  ) : (
                    <div
                      className={` transparent mt-[6px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                  {segWidths[1] && assetSegmentData["F&O"] > 0 ? (
                    <div
                      className={` mt-[25px] h-[20px] bg-[#25A86A] text-[#a8252500]`}
                      style={{ width: `${segWidths[1]}px` }}
                    >
                      {segWidths[1]}
                    </div>
                  ) : (
                    <div
                      className={` transparent mt-[25px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                  {segWidths[2] && assetSegmentData["CUR"] > 0 ? (
                    <div
                      className={` mt-[25px] h-[20px] bg-[#25A86A] text-[#a8252500]`}
                      style={{ width: `${segWidths[2]}px` }}
                    >
                      {segWidths[2]}
                    </div>
                  ) : (
                    <div
                      className={` transparent mt-[25px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                  {segWidths[3] && assetSegmentData["MCX"] > 0 ? (
                    <div
                      className={` mt-[25px] h-[20px] bg-[#25A86A] text-[#a8252500]`}
                      style={{ width: `${segWidths[3]}px` }}
                    ></div>
                  ) : (
                    <div
                      className={` transparent mt-[25px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                  {segWidths[4] && assetSegmentData["NCDEX"] > 0 ? (
                    <div
                      className={` mt-[25px] h-[20px] bg-[#25A86A] text-[#a8252500]`}
                      style={{ width: `${segWidths[4]}px` }}
                    ></div>
                  ) : (
                    <div
                      className={` transparent mt-[25px] h-[20px] w-[10px] opacity-0`}
                    ></div>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>

        <div className="flex w-[70px] flex-col gap-6 ">
          {selected === "Nature of trade"
            ? configData?.map((data, idx) => (
                <div key={idx} className="flex flex-col items-end gap-3  ">
                  <div className="whitespace-nowrap	">
                    ₹{data.data ? Math.floor(data?.data) : "0"}
                  </div>
                </div>
              ))
            : configSegmentData?.map((data, idx) => (
                <div key={idx} className="flex flex-col items-end gap-3">
                  <div className="whitespace-nowrap ">
                    {data.data ? Math.floor(data?.data) : "0"}
                  </div>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardBloackB;
